(function () {
  class PdpReelBlock extends HTMLElement {
    connectedCallback() {
      this.modalId = this.dataset.modalId;
      if (!this.modalId) return;

      this.modal = document.getElementById(this.modalId);
      if (!this.modal) return;

      this.mediaContainer = this.modal.querySelector('.pdp-reel-modal__media');
      this.labelEl = this.modal.querySelector('.pdp-reel-modal__label');
      this.showLabel = this.modal.dataset.showLabel === 'true';

      this.boundClick = this.handleClick.bind(this);
      this.addEventListener('click', this.boundClick);

      this.modalObserver = new MutationObserver(() => {
        if (!this.modal.hasAttribute('open')) {
          this.clearPreview();
        }
      });
      this.modalObserver.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundClick);
      this.modalObserver?.disconnect();
    }

    handleClick(event) {
      const trigger = event.target.closest('[data-reel-preview-trigger]');
      if (!trigger) return;

      event.preventDefault();
      this.openPreview(trigger);
    }

    openPreview(trigger) {
      const templateId = trigger.dataset.previewTemplate;
      const template = document.getElementById(templateId);
      if (!template || !this.mediaContainer) return;

      this.clearPreview();

      const video = template.content.querySelector('video');
      if (!video) return;

      const clone = video.cloneNode(true);
      this.mediaContainer.appendChild(clone);

      const label = trigger.dataset.previewLabel;
      if (this.labelEl && this.showLabel && label) {
        this.labelEl.textContent = label;
        this.labelEl.hidden = false;
      } else if (this.labelEl) {
        this.labelEl.hidden = true;
      }

      this.modal.open(trigger);

      if (clone.autoplay) {
        const playPromise = clone.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    }

    clearPreview() {
      if (this.mediaContainer) {
        this.mediaContainer.innerHTML = '';
      }

      if (this.labelEl) {
        this.labelEl.textContent = '';
        this.labelEl.hidden = true;
      }
    }
  }

  if (!customElements.get('pdp-reel-block')) {
    customElements.define('pdp-reel-block', PdpReelBlock);
  }
})();
